import * as yup from 'yup';

export const corporateSignUpSchema = yup.object().shape({
    name: yup
        .string()
        .required('Company Name is required')
        .min(3, 'Company Name must be at least 3 characters long')
        .max(50, 'Company Name cannot exceed 50 characters'),

    email: yup
        .string()
        .email('Please enter a valid email address')
        .required('Email Address is required'),

    password: yup
        .string()
        .min(8, 'Password must be at least 8 characters long')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter') // At least one uppercase
        .matches(/[0-9]/, 'Password must contain at least one number') // At least one number
        .matches(/[@$!%*?&]/, 'Password must contain at least one special character') // At least one special character
        .required('Password is required'),

    confirm_password: yup
        .string()
        .oneOf([yup.ref('password'), null], 'Passwords must match')
        .required('Confirm Password is required'),

    phone_no: yup
        .string()
        .matches(/^\+?\d{7,15}$/, 'Phone Number must be valid and contain 7-15 digits')
        .required('Phone Number is required'),

    ein_number: yup
        .string()
        .required('Company EIN Number is required'),

    about: yup
        .string()
        .max(300, 'About Company cannot exceed 300 characters')
        .notRequired(),

    tax_id_number: yup
        .string()
        .required('Tax ID Number is required'),

    registration_number: yup
        .string()
        .required('Registration Number is required'),

    work_permit_id: yup
        .string()
        .required('Work Permit ID is required'),

    // other: yup
    //     .mixed()
    //     .required('Supporting Document 1 is required')
    //     .test('fileSize', 'File size is too large', (value) => {
    //         return value && value.size <= 5 * 1024 * 1024; // Max 5MB
    //     })
    //     .test('fileType', 'Unsupported file format', (value) => {
    //         return value && ['image/jpeg', 'image/png', 'application/pdf'].includes(value.type);
    //     }),

    // supportingDocument2: yup
    //     .mixed()
    //     .required('Supporting Document 2 is required')
    //     .test('fileSize', 'File size is too large', (value) => {
    //         return value && value.size <= 5 * 1024 * 1024; // Max 5MB
    //     })
    //     .test('fileType', 'Unsupported file format', (value) => {
    //         return value && ['image/jpeg', 'image/png', 'application/pdf'].includes(value.type);
    //     }),

    logo: yup
        .mixed()
        .required('Company Logo is required')
        .test('fileSize', 'File size is too large', (value) => {
            return value && value.size <= 5 * 1024 * 1024; // Max 5MB
        })
        .test('fileType', 'Unsupported file format', (value) => {
            return value && ['image/jpeg', 'image/png', 'image/jpg'].includes(value.type);
        }),
});
